import {ClientEvent, MatrixClient} from 'matrix-js-sdk';

export const stopClient = async (client: MatrixClient): Promise<void> => {
  try {
    await client.removeAllListeners(ClientEvent.Sync);
    await client.stopClient();
  } catch (error) {
    console.error('Error stopping Matrix client', error);
    throw error;
  }
};
